import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { API_BIS_DATA_SYNC_FAIL_LOGS } from "@/configs/Apis";
import DuduAjax from "@/utils/DuduAjax";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataSyncFailLogs',
  props: {
    visible: { type: Boolean },
    requestUuid: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  visible: boolean;
  requestUuid: string;
};





const store = useStore();
const isLoading = computed(() => store.state.isLoading);

const failLogItems = ref<Array<any>>([]);
const failLogCount = ref(0);
const failLogPageSize = ref(10);
const failLogPageIndex = ref(1);

const formatTime = (value: string) => {
  if (!value) {
    return "-";
  }
  return value.replace("T", " ").split(".")[0];
};

const loadFailLogs = () => {
  DuduAjax.get<{ count: number; data: Array<any> }>(API_BIS_DATA_SYNC_FAIL_LOGS, {
    requestUuid: props.requestUuid,
    page: failLogPageIndex.value - 1,
    pageSize: failLogPageSize.value,
  }).then((entity) => {
    failLogCount.value = entity.count;
    failLogItems.value = entity.data || [];
  });
};

watch(
  () => props.visible,
  (val) => {
    if (val) {
      failLogPageIndex.value = 1;
      loadFailLogs();
    }
  }
);

const onFailLogPageChange = (page: number) => {
  failLogPageIndex.value = page;
  loadFailLogs();
};

const onFailLogPageSizeChange = (size: number) => {
  failLogPageSize.value = size;
  failLogPageIndex.value = 1;
  loadFailLogs();
};

const emitClose = () => {
  emit("close");
};

return { __sfc: true,props, emit, store, isLoading, failLogItems, failLogCount, failLogPageSize, failLogPageIndex, formatTime, loadFailLogs, onFailLogPageChange, onFailLogPageSizeChange, emitClose }
}

})